import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const workLimitMustJoinAssign = async (params: object) => {
  return await GET({
    url: Api.workLimitMustJoinAssign,
    params,
    showError: false
  })
}
export const assignMod = async (params: object) => {
  return await GET({
    url: Api.assignMod,
    params,
    showError: false
  })
}
